<script>
import { productBrandService } from "../../services";
import { required } from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, success_message } from "../../Helper/helper";

export default {
  components: { productBrandService},
    data() {
        return {
            is_disable: false,
            url: null,
            config: config,
            typeform: {
                company_name:"",
                status: "1",
                street_no: "",
                street: "",
                city: "",
                postalcode: "",
                username:"",
                password:"",
                image_url:"",
                status: 1,
            },
        };
    },
    validations: {
        typeform: {
            company_name:{
                required,
            },
            city:{
                required,
            },
            postalcode:{
                required,
            },
            street:{
                required,
            },
            street_no:{
                required,
            }
        },
    },
    methods: {
        alphabetic(e){   
            const floating = /^[A-Za-z ]+$/;
            let char = String.fromCharCode(e.keyCode);
            if (floating.test(char)) return true;
            else e.preventDefault();
        },
        contactNumber(evt) {
            let val1 = evt.target.value;
            if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
                evt.preventDefault();
            }
            let partlen = val1.split("+").length - 1;
            if (evt.keyCode == 43 && partlen > 0) {
                evt.preventDefault();
            } else if (evt.keyCode == 43 && (evt.target.selectionStart !== undefined && evt.target.selectionStart !== 0)) {
                evt.preventDefault();
            }
        },
        addProducerCompany(){
            this.$v.typeform.$touch();
            if (this.$v.typeform.$invalid) {
                setTimeout(()=>{
                    $('html, body').animate({
                        scrollTop: $(".is-invalid:first").offset().top-$('#page-topbar').height()-50
                    }, 200, function() {
                        $(".is-invalid:first").focus();
                    });
                },300);
                return;
            } else {
                this.is_disable = true;
                productBrandService.addProducerCompany(this.typeform).then((response) => {
                    if (response.data.code === 200) {
                        success_message(response.data.message);
                        this.$router.push({ name: "producer-company-list" });
                    } else {
                        error_message(response.data.message);
                    }
                    this.is_disable = false;
                });
            }
        },
    },
};

</script>
<template>
    <form @submit.prevent="addProducerCompany">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">{{ trans.get('__JSON__.Producer Information') }}</h4>
                <p class="card-title-desc"></p>
                <div class="row">

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Company Name')}}</label>
                            <input
                                id="company_name"
                                v-model="$v.typeform.company_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Company Name')"
                                name="company_name"
                                :class="{ 'is-invalid': $v.typeform.company_name.$error }"
                            />
                            <div v-if="$v.typeform.company_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.company_name.required">{{ trans.get('__JSON__.Please enter company name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street')}}</label>
                            <input
                                id="street"
                                v-model="$v.typeform.street.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street')"
                                name="street"
                                v-on:keypress="alphabetic($event,typeform.street)"
                                :class="{ 'is-invalid': $v.typeform.street.$error }"
                            />
                            <div v-if="$v.typeform.street.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.street.required">{{ trans.get('__JSON__.Please enter street name') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Street Number')}}</label>
                            <input
                                maxlength="5"
                                minlength="1"
                                id="street_no"
                                v-model="$v.typeform.street_no.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Street Number')"
                                name="street_no"
                                v-on:keypress="contactNumber($event,typeform.street_no)"
                                :class="{ 'is-invalid': $v.typeform.street_no.$error }"
                            />
                            <div v-if="$v.typeform.street_no.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.street_no.required">{{ trans.get('__JSON__.Please enter street number') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.City')}}</label>
                            <input
                                id="city"
                                v-model="$v.typeform.city.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.City')"
                                name="city"
                                v-on:keypress="alphabetic($event,typeform.city)"
                                :class="{ 'is-invalid': $v.typeform.city.$error }"
                            />
                            <div v-if="$v.typeform.city.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.city.required">{{ trans.get('__JSON__.City Name Error') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.trans('__JSON__.Postal Code')}}</label>
                            <input
                                maxlength="10"
                                minlength="3"
                                id="postalcode"
                                v-model="$v.typeform.postalcode.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Postal Code')"
                                name="postalcode"
                                :class="{ 'is-invalid': $v.typeform.postalcode.$error }"
                            />
                            <div v-if="$v.typeform.postalcode.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.postalcode.required">{{ trans.get('__JSON__.Please enter postal code') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Image Database URL')}}</label>
                            <input
                                id="image_url"
                                v-model="typeform.image_url"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Image Database URL')"
                                name="image_url"
                            />
                            <!--  :class="{ 'is-invalid': $v.typeform.image_url.$error }"<div v-if="$v.typeform.image_url.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.image_url.required">{{ trans.get('__JSON__.Please Image Database URL') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.User Name')}}</label>
                            <input
                                id="user_name"
                                v-model="typeform.user_name"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.User Name')"
                                name="user_name"
                            />
                            <!--  :class="{ 'is-invalid': $v.typeform.image_url.$error }"<div v-if="$v.typeform.image_url.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.image_url.required">{{ trans.get('__JSON__.Please Image Database URL') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label>{{ trans.trans('__JSON__.Password')}}</label>
                            <input
                                id="password"
                                v-model="typeform.password"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Password')"
                                name="password"
                            />
                            <!--  :class="{ 'is-invalid': $v.typeform.image_url.$error }"<div v-if="$v.typeform.image_url.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.image_url.required">{{ trans.get('__JSON__.Please Image Database URL') }}</span>
                            </div> -->
                        </div>
                    </div>

                    <div class="col-sm-6 vendor-status">
                        <b-form-group
                            id="input-group-1"
                            :label="trans.get('__JSON__.Status')"
                            label-for="status"
                            >
                            <label class="switch">
                                <input
                                type="checkbox"
                                id="togBtn"
                                name="status"
                                v-model="typeform.status"
                                class="switch-on"
                                true-value="1"
                                false-value="0"
                                />
                                <div class="slider round">
                                <span class="on">{{ trans.get("__JSON__.Active") }}</span>
                                <span class="off">{{ trans.get("__JSON__.Inactive") }}</span>
                                </div>
                            </label>
                        </b-form-group>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <button class="btn btn-primary mr-1 mt-3" :disabled="is_disable">{{ trans.get('__JSON__.Add Producer Company') }}</button>
                        <router-link
                            :to="{name:'producer-company-list'}"
                        >
                            <b-button 
                                type="button" 
                                variant="secondary" 
                                class="mt-3">   
                                {{ trans.get('__JSON__.Cancel') }}
                            </b-button>
                        </router-link>    
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>